import React, {useEffect, useState} from 'react';
import {Platform, View} from 'react-native';
import {makeStyles} from 'rne-netzon';
import {RNEText} from '../../components';
import {REACT_APP_BASE_WEB_URL} from '../../server/api/api.config';

const ConsultationPaymentFailScreen = () => {
  const styles = useStyles();

  const [failCode, setFailCode] = useState('');

  useEffect(() => {
    if (Platform.OS === 'web') {
      const currentUrl = location.href;
      setFailCode(currentUrl.split('=')[1]);

      setTimeout(() => {
        const url = `${REACT_APP_BASE_WEB_URL}main/consultation/list?screen=ongoing&tab=1`;
        window.open(url, '_self');
      }, 5000);
    }
  }, []);

  return (
    <View style={styles.mainContainer}>
      <View style={styles.titleContainer}>
        <RNEText
          label="Payment Failed!"
          color="error"
          weight="600"
          variant="title"
        />
        <RNEText label={failCode} color="error" variant="body" align="center" />
      </View>
      <View style={styles.subtitleContainer}>
        <RNEText
          label="You will be redirected back to the app. It might take a few seconds."
          color="black"
          variant="body"
        />
      </View>
    </View>
  );
};

export default ConsultationPaymentFailScreen;

const useStyles = makeStyles({
  mainContainer: {
    padding: 100,
    alignItems: 'center',
  },
  titleContainer: {
    paddingVertical: 40,
  },
  subtitleContainer: {
    paddingVertical: 20,
  },
});
